import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatCurrency, formatDate } from "../lib/api";
import { ArrowLeft } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

export default function OrganizerAttendees() {
  const { id } = useParams();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get(`/organizer/events/${id}/attendees`).then(({ data }) => setRows(data));
  }, [id]);

  return (
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
      <Link to="/organizer" className="mb-4 inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-amber-400"><ArrowLeft className="h-4 w-4" /> Back to console</Link>
      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-widest text-amber-400">Event attendees</div>
        <h1 className="font-display text-2xl font-black uppercase text-zinc-50">{rows[0]?.event_title || "Attendees"}</h1>
      </div>
      <div className="overflow-hidden rounded-2xl border border-zinc-800 bg-[#3A1020]">
        <Table>
          <TableHeader>
            <TableRow className="border-zinc-800 hover:bg-transparent">
              <TableHead className="text-zinc-400">Attendee</TableHead>
              <TableHead className="text-zinc-400">Email</TableHead>
              <TableHead className="text-zinc-400">Tier</TableHead>
              <TableHead className="text-zinc-400">Qty</TableHead>
              <TableHead className="text-zinc-400">Total</TableHead>
              <TableHead className="text-zinc-400">Booked</TableHead>
              <TableHead className="text-zinc-400">Code</TableHead>
              <TableHead className="text-zinc-400">Check-in</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow><TableCell colSpan={8} className="py-10 text-center text-zinc-500">No bookings yet.</TableCell></TableRow>
            ) : rows.map((r) => (
              <TableRow key={r.id} className="border-zinc-800">
                <TableCell className="text-zinc-100">{r.user_name}</TableCell>
                <TableCell className="font-mono text-xs text-zinc-300">{r.user_email}</TableCell>
                <TableCell className="text-zinc-200">{r.tier_name}</TableCell>
                <TableCell className="text-zinc-200">{r.quantity}</TableCell>
                <TableCell className="font-mono text-amber-400">{formatCurrency(r.total)}</TableCell>
                <TableCell className="text-xs text-zinc-400">{formatDate(r.created_at)}</TableCell>
                <TableCell className="font-mono text-xs text-amber-400">{r.booking_code}</TableCell>
                <TableCell>{r.checked_in_at ? <span data-testid={`checkedin-${r.id}`} className="rounded-full bg-amber-500/15 px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-amber-400">In · {formatDate(r.checked_in_at)}</span> : <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Not yet</span>}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
